import React from 'react'
import { useLocation } from 'react-router-dom'

import routes from '../routes'

import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'

const separatorSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      marginTop: '3px'
      // margin: '0px 8px',
      // marginTop: 'auto', marginBottom: 'auto'
    }}
  >
    <path
      d="M6 12L10 8L6 4"
      stroke="#93949D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const AppBreadcrumb = () => {
  const currentLocation = useLocation().pathname
  // змінено
  // const getRouteName = (pathname, routes) => {
  //   const currentRoute = routes.find((route) => route.path === pathname)
  //   return currentRoute ? currentRoute.name : false
  // }
  //змінено

  //додано
  const matchDynamicRoute = (pathname, routePath) => {
    const pathSegments = pathname.split('/').filter(Boolean)
    const routeSegments = routePath.split('/').filter(Boolean)

    if (pathSegments.length !== routeSegments.length) return false

    return routeSegments.every((segment, index) =>
      segment.startsWith(':') || segment === pathSegments[index]
    )
  }

  const getRouteName = (pathname, routes) => {
    const match = routes.find((route) => matchDynamicRoute(pathname, route.path))
    return match ? match.name : false
  }
  //додано

  const getBreadcrumbs = (location) => {
    // console.log('location', location)
    const breadcrumbs = []
    //додав фільтр
    location.split('/')
      .filter(Boolean)
      .reduce((prev, curr, index, array) => {
        const currentPathname = `${prev}/${curr}`.replace(/\/+/g, '/')
        const routeName = getRouteName(currentPathname, routes)
        routeName &&
          breadcrumbs.push({
            pathname: currentPathname,
            name: routeName,
            active: index + 1 === array.length ? true : false,
          })
        return currentPathname
      }, '')
    //
    if (breadcrumbs.length === 0) {
      const fallbackRouteName = getRouteName(location, routes)
      if (fallbackRouteName) {
        breadcrumbs.push({
          pathname: location,
          name: fallbackRouteName,
          active: true,
        })
      }
    }

    return breadcrumbs
  }

  const breadcrumbs = getBreadcrumbs(currentLocation)
  // console.log('breadCrumbs', breadcrumbs)

  return (
    <CBreadcrumb className="m-0 ms-2 d-flex" style={{ gap: '10px', alignItems: 'center' }} >
      <CBreadcrumbItem href="/"
        className='breadcrumb-link'
      >Home</CBreadcrumbItem>
      {breadcrumbs.map((breadcrumb, index) => {

        // return (
        //   <CBreadcrumbItem className='breadcrumb-link'
        //     {...(breadcrumb.active ? { active: true } : { href: breadcrumb.pathname })}
        //     key={index}
        //   >
        //     {breadcrumb.name}
        //   </CBreadcrumbItem>
        // )

        return <React.Fragment key={index}>

          {separatorSvg}
          <CBreadcrumbItem className='breadcrumb-link'
            {...(breadcrumb.active ? { active: true } : { href: breadcrumb.pathname })}
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            {breadcrumb.name}
          </CBreadcrumbItem>

        </React.Fragment>
      }

      )}
    </CBreadcrumb>
  )
}

export default React.memo(AppBreadcrumb)
